import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { CheckoutModal } from '@/components/CheckoutModal';
import { SEO } from '@/components/SEO';
import { useShop } from '@/context/ShopContext';

// Checkout previously only existed as a modal triggered from the cart
// drawer, with no URL of its own — not bookmarkable, no back/forward
// support. This gives it a real route while reusing the same component
// (and its real order-placement logic) rather than duplicating it.
export function CheckoutPage() {
  const navigate = useNavigate();
  const { cart } = useShop();
  const [ordered, setOrdered] = useState(false);

  // Without this, navigating straight to /checkout with an empty cart offered a
  // "Place Order — R0.00" button that submitted an order with no line items.
  // `ordered` matters because placing an order clears the cart — without it
  // the confirmation screen (order number, EFT banking details) was instantly
  // replaced by the empty-cart state.
  if (cart.length === 0 && !ordered) {
    return (
      <div className="min-h-screen" style={{ background: '#F7F5EE' }}>
        <SEO title="Checkout | Marple & Co" description="Complete your order." path="/checkout" />
        <div className="container-marple py-24 text-center">
          <ShoppingBag className="w-16 h-16 mx-auto mb-6" style={{ color: '#D9B38C' }} />
          <h1 className="font-serif text-3xl font-bold mb-3" style={{ color: '#1A2E12' }}>
            Your cart is empty
          </h1>
          <p className="mb-8" style={{ color: '#6B7B6E' }}>
            Add a ritual to your cart before checking out.
          </p>
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-semibold transition-transform hover:scale-105"
            style={{ background: '#BDD630', color: '#567D38' }}
          >
            Browse the collection
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEO title="Checkout | Marple & Co" description="Complete your order." path="/checkout" />
      <CheckoutModal isOpen onClose={() => navigate('/shop')} onOrderComplete={() => setOrdered(true)} />
    </>
  );
}

export default CheckoutPage;
